import { useState } from 'react';
import PropTypes from 'prop-types';
import Sidebar from '../components/Sidebar';
import TemplateLibrary from '../components/customForms/TemplateLibrary';
import FormBuilder from '../components/customForms/FormBuilder';
import { useMode } from '../context/ModeContext';
import { useUserRole } from '../hooks/useUserRole';

export default function CustomForms({ token, onLogout }) {
  const { activeMode } = useMode();
  const { isLoading, isReceptionistOnly, getRoleForClinic, clinics, user } = useUserRole();
  const [editing, setEditing] = useState(null);
  const userId = user?.id ? String(user.id) : (localStorage.getItem('user_id') || '');
  if (isLoading) return <div>Loading...</div>;
  if (isReceptionistOnly) return (
    <div className="page-container">
      <Sidebar active="custom-forms" onLogout={onLogout} />
      <main className="main-content flex items-center justify-center min-h-[60vh]">
        <div className="text-center space-y-3 max-w-md p-6 bg-slate-50 rounded-xl border border-slate-200">
          <h2 className="text-lg font-semibold text-slate-900">Access Restricted</h2>
          <p className="text-sm text-slate-600">Custom forms are available to clinical staff only.</p>
        </div>
      </main>
    </div>
  );

  const administeredClinics = (clinics || []).filter(c => getRoleForClinic(c.id) === 'admin');
  const isClinicAdmin = activeMode !== 'personal' && (
    activeMode === 'everything'
      ? administeredClinics.length > 0
      : getRoleForClinic(activeMode) === 'admin'
  );

  return (
    <div className="page-container">
      <Sidebar active="custom-forms" onLogout={onLogout} />
      <main className="main-content">
        {editing ? (
          <FormBuilder token={token} family={editing.family} initialDraft={editing.draft} onClose={() => setEditing(null)} />
        ) : (
          <TemplateLibrary
            token={token}
            userId={userId || ''}
            activeMode={activeMode}
            isClinicAdmin={Boolean(isClinicAdmin)}
            administeredClinics={administeredClinics}
            getRoleForClinic={getRoleForClinic}
            onEdit={(draft, family) => setEditing({ draft, family })}
          />
        )}
      </main>
    </div>
  );
}

CustomForms.propTypes = { token: PropTypes.string, onLogout: PropTypes.func };
